import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import RenderTable from "components/table";
import { bindActionCreators } from "redux";
import { Creators as LocationActions } from "store/location/location-duck";
import { IItems } from "store/location/location-model";
import { Creators as UserSessionActions } from "store/user-session/user-session-duck";
import { MenuItemActive } from "store/user-session/user-session-model";
import ColumnsTable from "./columnsTable";
import * as S from "./styled/index.styled";

interface IPropsScreenLocationGrid {
  items?: Array<IItems>;
  totalItems?: number;
  orderBy?: string;
  ascending?: string;
  itemsByPage?: number;
  pageIndex?: number;
  isAdmin?: boolean;
  searchFilter?: string;
  isLoadingTable: boolean;
}
interface IDispatchProps {
  locationsFetchRegisterAsync: (...args) => void;
  locationsChangeFieldValue: (...args) => void;
  userSessionMenuItemActive: (...args) => void;
}

type IProps = IPropsScreenLocationGrid & IDispatchProps;

const LocationGrid = ({
  items,
  totalItems,
  locationsFetchRegisterAsync,
  locationsChangeFieldValue,
  userSessionMenuItemActive,
  isAdmin,
  searchFilter,
  pageIndex,
  isLoadingTable,
}: IProps) => {
  const router = useNavigate();

  const fetchLocation = useCallback(() => locationsFetchRegisterAsync(), [locationsFetchRegisterAsync]);

  useEffect(() => {
    fetchLocation();
  }, [fetchLocation]);

  const handleTableChange = (pagination, sorter) => {
    locationsChangeFieldValue("orderBy", sorter.field);
    locationsChangeFieldValue("ascend", sorter.order);
    locationsChangeFieldValue("itemsByPage", pagination.pageSize);
    locationsChangeFieldValue("pageIndex", pagination.current);
    fetchLocation();
  };

  useEffect(() => {
    if (searchFilter !== "" || searchFilter === null) {
      locationsChangeFieldValue("pageIndex", 1);
      fetchLocation();
    }
  }, [searchFilter]);

  const handleClick = ({ id }) => {
    userSessionMenuItemActive(MenuItemActive.LOCATION_EDIT);
    router(`/private/location/form/${id}`);
  };

  return (
    <S.LocationContainer>
      <RenderTable
        columnsTable={ColumnsTable({ handleClick, isAdmin })}
        items={items}
        totalItems={totalItems}
        handleTableChange={handleTableChange}
        pageIndex={pageIndex}
        isLoadingTable={isLoadingTable}
      />
    </S.LocationContainer>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...LocationActions, ...UserSessionActions }, dispatch);

const mapStateToProps = (state) => ({
  items: state.Location.items,
  totalItems: state.Location.totalItems,
  orderBy: state.Location.filter.orderBy,
  ascending: state.Location.filter.ascending,
  itemsByPage: state.Location.filter.itemsByPage,
  pageIndex: state.Location.filter.pageIndex,
  isAdmin: state.UserSession.isAdmin,
  searchFilter: state.Location.searchFilter,
  isLoadingTable: state.Location.isLoadingTable,
});

export default connect(mapStateToProps, mapDispatchToActions)(LocationGrid);
